<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheHeader />
    
    <TheSidebar />

    <div class="c-wrapper">
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </div>

    <CenterLoading />
    <DialogMessage />
    <SignIn />
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from '../TheFooter'
import { mapActions } from "vuex";

export default {
  name: 'TheContainer',
  components: { TheSidebar, TheHeader, TheFooter },
  mounted() { this.loadUserProfile(); },
  methods: {
    ...mapActions("user", ["getProfile"]),
    async loadUserProfile() { try { await this.getProfile(); } catch (err) { console.error(err); } },
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* ดันเนื้อหาลงมา 60px เพื่อไม่ให้โดน Header บัง */
.c-body {
  padding-top: 60px !important;
}
</style>